import React from "react";
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../PageNotFound/PageNotFound";
import Index from "../MainWebsite/pages/Index/Index";
import SayHi from "../MainWebsite/pages/SayHi/SayHi";
import Navbar from "../MainWebsite/Shared/NavBar/Navbar";
import PersonDetails from "../MainWebsite/pages/PersonDetails/PersonDetails";
import AboutUs from "../MainWebsite/pages/AboutUs/AboutUs";
import Services from "../MainWebsite/pages/Services/Services";
import ConsciousBusiness from "../MainWebsite/pages/ConsciousBusiness/ConsciousBusiness";
import OurImpact from "../MainWebsite/pages/OurImpact/OurImpact";
import Footer from "../MainWebsite/Shared/Footer/Footer";

function MainRoutes() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="" index element={<Index />} />
        <Route path="/contact" element={<SayHi />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/our-impact" element={<OurImpact />} />
        <Route path="/conscious-business" element={<ConsciousBusiness />} />
        <Route path="/person/:name" element={<PersonDetails />} />
      </Routes>
      <Footer />
    </>
  );
}

export default MainRoutes;
